import { ObserversModule } from '@angular/cdk/observers'
import { CommonModule } from '@angular/common'
import { Component, inject, input } from '@angular/core'

import { Store } from '@ngrx/store'

import { AiIconsModule } from '../../../../common/icons/ai-icons.module'
import { AiActions } from '../../../../store/ai.actions'
import { AiSelectors } from '../../../../store/ai.selectors'

@Component({
  selector: 'flx-ai-preview-area-header',
  imports: [CommonModule, AiIconsModule, ObserversModule],
  templateUrl: './preview-area-header.component.html',
})
export class AiPreviewAreaHeaderComponent {
  #store = inject(Store)

  title = input('')
  hasInfoButton = input(false)

  isLastMsgError = this.#store.selectSignal(AiSelectors.isLastMsgError)

  keepDraft(): void {
    this.#store.dispatch(AiActions.keepDraftClick())
  }

  discardDraft(): void {
    this.#store.dispatch(AiActions.discardDraftClick())
  }

  draftInfo(): void {
    this.#store.dispatch(AiActions.draftInfoClick())
  }
}
